import { useMemo } from 'react';

import { useAuthStore } from '@/modules/user/stores';

import useEmployeePersonalInfoQuery from '../queries/useEmployeePersonalInfo.query';


const useIsAddressUndeliverable = () => {
  const auth = useAuthStore((state) => state.auth);
  const { mailingAddress, isLoading, refetch } = useEmployeePersonalInfoQuery();

  const isUndeliverable = useMemo(
    () => !!auth && !!mailingAddress?.address?.undeliverable,
    [auth, mailingAddress]
  );

  const addressId = mailingAddress?.address?.id;

  return { isUndeliverable, isLoading, addressId, refetch };
};

export default useIsAddressUndeliverable;
